module.exports = __webpack_public_path__ + "img/checkIcon@3x.186c17ce.png";